import { render, staticRenderFns } from "./evidence.vue?vue&type=template&id=811311e6&scoped=true&"
import script from "./evidence.vue?vue&type=script&lang=js&"
export * from "./evidence.vue?vue&type=script&lang=js&"
import style0 from "./evidence.vue?vue&type=style&index=0&id=811311e6&scoped=true&lang=css&"
import style1 from "./evidence.vue?vue&type=style&index=1&id=811311e6&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811311e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('811311e6')) {
      api.createRecord('811311e6', component.options)
    } else {
      api.reload('811311e6', component.options)
    }
    module.hot.accept("./evidence.vue?vue&type=template&id=811311e6&scoped=true&", function () {
      api.rerender('811311e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/evidence.vue"
export default component.exports